import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import nl from 'vuetify/es5/locale/nl';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { nl },
      current: 'nl',
    },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: "#00b5cb",
        secondary: "#005875",
        accent: "#4c4e4e"
      }
    }
  },
});
